<template>
    <div class="list-item-alt">
        <div class="list-item-info-alt">
            <strong v-if="searchQuery" v-html="highlightMatch(category.name, searchQuery)"
                :class="{ 'search-match': category.isMatch }"></strong>
            <strong v-else>{{ category.name }}</strong>

            <span v-if="category.matchCount > 0" class="match-badge">
                {{ category.matchCount }}
            </span>

            <div class="list-item-info-alt">
                <div class="option" style="padding-left: 0em;">
                    <button class="btn-collapsible" @click="toggleList" :aria-expanded="showList"
                        :aria-label="`${showList ? 'Colapsar' : 'Expandir'} ${category.name}`">
                        <font-awesome-icon v-if="!showList" icon="chevron-down"
                            style="font-size: 2em;"></font-awesome-icon>
                        <font-awesome-icon v-else icon="chevron-up" style="font-size: 2em;"></font-awesome-icon>
                    </button>
                </div>
            </div>
        </div>

        <transition name="expand">
            <div class="items-list-collap" v-show="showList">
                <div v-for="(layer, j) in category.layers" :key="j"
                    :class="['layer-item', { 'search-match-layer': isLayerMatch(layer) }]">

                    <div class="layer-item-content">
                        <input type="checkbox" :id="`layer-${index}-${j}`" v-model="layer.selected"
                            @change="clickLayer(j, layer.selected)" :aria-label="`Seleccionar capa ${layer.name}`">
                        <label :for="`layer-${index}-${j}`" class="layer-label">
                            <span v-if="searchQuery" v-html="highlightMatch(layer.name, searchQuery)"></span>
                            <span v-else>{{ layer.name }}</span>
                        </label>
                    </div>

                    <div class="layer-actions">
                        <!-- Control de Opacidad -->
                        <div class="opacity-control">
                            <div class="opacity-dot" @click="toggleOpacitySlider(j)"
                                :title="`Opacidad: ${getLayerOpacity(layer)}%`"
                                :class="{ 'active': activeOpacityLayer === j }"></div>

                            <!-- Slider que aparece al hacer click -->
                            <transition name="fade">
                                <div v-if="activeOpacityLayer === j" class="opacity-slider-panel">
                                    <span class="opacity-label">Opacidad</span>
                                    <input type="range" min="0" max="1" step="0.01"
                                        :value="layer.opacity !== undefined ? layer.opacity : 1"
                                        @input="updateOpacity($event, j, layer)" class="opacity-slider" @click.stop />
                                    <span class="opacity-value">{{ getLayerOpacity(layer) }}%</span>
                                </div>
                            </transition>
                        </div>

                        <!-- 🔍 NUEVO BOTÓN DE LUPA -->
                        <font-awesome-icon icon="search" class="fa-lg search-icon action-icon"
                            @click="clickSearchLayer(layer)" :aria-label="`Buscar o ver detalles de ${layer.name}`" />

                        <font-awesome-layers @click="setLayerMenu(j)" class="fa-lg layer-menu-icon action-icon"
                            :aria-label="`Menú de opciones para ${layer.name}`">
                            <font-awesome-icon icon="ellipsis-h" />
                        </font-awesome-layers>
                    </div>

                    <ul v-if="menuId == j" class="layerMenu" v-click-outside="hideMenu"
                        @click="clickShowAttributes(layer)">
                        Ver tabla de atributos
                    </ul>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import { formatter } from '@/components/mixin/formatter.js'
import vClickOutside from 'v-click-outside'
import { attributesTableService } from '@/services/layers/attributesTable.js'


export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        category: {
            type: Object,
            required: true
        },
        searchQuery: {
            type: String,
            default: ''
        },
        isSearchActive: {
            type: Boolean,
            default: false
        }
    },

    mixins: [formatter],

    directives: {
        clickOutside: vClickOutside.directive
    },

    data() {
        return {
            showList: false,
            selected: false,
            menuId: -1,
            activeOpacityLayer: null // ID de la capa cuyo slider está activo
        }
    },

    watch: {
        /**
         * Auto-expand when search results appear
         */
        'category.autoExpand': {
            immediate: true,
            handler(shouldExpand) {
                if (shouldExpand && this.isSearchActive) {
                    this.showList = true;
                }
            }
        },

        /**
         * Collapse when search is cleared
         */
        isSearchActive: {
            handler(isActive) {
                if (!isActive) {
                    this.showList = false;
                }
            }
        }
    },

    methods: {
        /**
         * Toggle list expansion
         */
        toggleList() {
            this.showList = !this.showList;
        },

        /**
         * Handle layer checkbox click
         */
        clickLayer(layerIndex, isSelected) {
            const layer = this.category.layers[layerIndex];
            if (isSelected) {
                this.$emit("selectLayer", this.category, layer);
            } else {
                this.$emit("removeLayer", this.category, layer);
            }
        },

        /**
         * Toggle opacity slider visibility
         */
        toggleOpacitySlider(layerIndex) {
            // Si ya está abierto, cerrar; si no, abrir
            this.activeOpacityLayer = this.activeOpacityLayer === layerIndex ? null : layerIndex;
        },

        getLayerOpacity(layer) {
            const val = layer.opacity !== undefined ? layer.opacity : 1;
            return Math.round(val * 100);
        },

        /**
         * Update layer opacity
         */
        updateOpacity(event, layerIndex, layer) {
            const newOpacity = parseFloat(event.target.value);
            this.$set(layer, 'opacity', newOpacity);
            this.$emit("updateOpacity", {
                category: this.category,
                layer: layer,
                opacity: newOpacity
            });
        },

        /**
         * Toggle layer menu
         */
        setLayerMenu(id) {
            this.menuId = this.menuId === id ? -1 : id;
        },

        /**
         * Hide layer menu
         */
        hideMenu() {
            this.menuId = -1;
        },

        /**
         * Show attributes table for layer
         */
        clickShowAttributes(layer) {
            console.log("clickShowAttributes", layer);
            this.hideMenu();
            attributesTableService.openTable(layer);
        },

        /**
         * Check if a layer matches the search query
         */
        isLayerMatch(layer) {
            if (!this.searchQuery) return false;
            return layer.name.toLowerCase().includes(this.searchQuery.toLowerCase());
        },

        /**
         * Highlight matched text in a string
         */
        highlightMatch(text, query) {
            if (!query || !text) return text;

            // Escape special regex characters
            const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`(${escapedQuery})`, 'gi');

            return text.replace(regex, '<span class="search-highlight">$1</span>');
        },
        clickSearchLayer(layer) {
            console.log("Clic en lupa para capa:", layer);
            this.$emit("searchLayer", this.category, layer);
        }

    }
}
</script>

<style scoped lang="scss">
p {
    margin: 0.5em 0;
}

.list-item-alt {
    color: #4D4D4D;
    font-size: 0.9em;
    padding: 0.25em 1em;
    margin-top: 0.5em;
    margin: 0.25em 0em;
}

.bottom-menu-fixed {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.options-fixed {
    display: inherit;
    align-items: start;
    position: relative;
    cursor: pointer;
}

.item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #FCFCFC;
    padding: 10px;
    border-bottom: 1px solid #DBDBDB;
    color: #4D4D4D;
    font-size: 1em;
}

.training-title {
    margin: 0.5em;
}

.training-text {
    display: block;
    margin: 0.5em;
}

.list-item-info-alt {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.items-list-collap {
    div {
        padding: 0.125em 0em;
    }
}

.btn-collapsible {
    border: none;
    background: transparent;
    color: #006FB3;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
        color: #004B7A;
    }

    &:focus {
        outline: 2px solid #fe6565;
        outline-offset: 2px;
    }
}

/* Search-related styles - Bold Contrast */
.search-match {
    color: #006FB3;
    font-weight: 700;
}

.match-badge {
    display: inline-block;
    background: #006FB3;
    color: white;
    font-size: 0.7em;
    font-weight: 700;
    padding: 3px 8px;
    border-radius: 12px;
    margin-left: 8px;
    border: 2px solid #004B7A;
    box-shadow: 0 2px 4px rgba(0, 111, 179, 0.3);
}

.layer-item {
    padding: 8px 4px;
    border-radius: 4px;
    transition: all 0.2s;
    overflow: visible;
    /* Permitir que el panel de opacidad salga */
    display: flex;
    /* Flex para alinear todo en una línea */
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    position: relative;
    /* Para posicionar el menú contextual */

    &:hover {
        background: rgba(0, 111, 179, 0.05);
    }

    &.search-match-layer {
        background: rgba(255, 235, 59, 0.15);
        border-left: 4px solid #006FB3;
        padding-left: 4px;
        box-shadow: inset 0 0 0 1px rgba(0, 111, 179, 0.2);
    }
}

.layer-item-content {
    display: flex;
    align-items: center;
    flex: 1;
    /* Ocupa el espacio disponible */
    overflow: hidden;
    /* Truncar texto si es necesario */
    margin-right: 8px;
}

.layer-label {
    font-size: 0.9em;
    font-weight: normal;
    margin-left: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.layer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    /* No encoger iconos */
}

.action-icon {
    cursor: pointer;
    color: #666;

    &:hover {
        color: #006FB3;
    }
}

/* Search highlight styling */
::v-deep .search-highlight {
    background: linear-gradient(135deg, #ffeb3b 0%, #ffc107 100%);
    color: #000;
    padding: 2px 4px;
    border-radius: 3px;
    font-weight: 700;
    border: 1px solid #ff9800;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.layer-menu-icon {
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.1);
    }
}

/* Expand/collapse transition */
.expand-enter-active {
    transition: all 0.3s ease;
    max-height: 1000px;
    overflow: hidden;
}

.expand-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
    max-height: 1000px;
    overflow: hidden;
}

.expand-enter,
.expand-leave-to {
    max-height: 0;
    opacity: 0;
}

/* Opacity Control */
.opacity-control {
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 8px;
}

.opacity-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #4a90e2;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;

    &:hover {
        background: #357abd;
        transform: scale(1.15);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    }

    &.active {
        background: #357abd;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.3);
    }
}

.opacity-slider-panel {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    padding: 8px 12px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 1000;
    min-width: 180px;
    border: 2px solid #4a90e2;

    &::before {
        content: '';
        position: absolute;
        right: -8px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 8px solid #4a90e2;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
    }

    &::after {
        content: '';
        position: absolute;
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid white;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
    }
}

.opacity-label {
    font-size: 11px;
    font-weight: 600;
    color: #4a90e2;
    white-space: nowrap;
}

.opacity-slider {
    flex: 1;
    height: 4px;
    -webkit-appearance: none;
    appearance: none;
    background: linear-gradient(to right, #e0e0e0 0%, #4a90e2 100%);
    outline: none;
    border-radius: 2px;
    cursor: pointer;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 16px;
        height: 16px;
        background: #4a90e2;
        cursor: pointer;
        border-radius: 50%;
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        transition: all 0.2s;

        &:hover {
            transform: scale(1.2);
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
        }
    }

    &::-moz-range-thumb {
        width: 16px;
        height: 16px;
        background: #4a90e2;
        cursor: pointer;
        border-radius: 50%;
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        transition: all 0.2s;

        &:hover {
            transform: scale(1.2);
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
        }
    }
}

.opacity-value {
    font-size: 11px;
    color: #333;
    font-weight: 600;
    min-width: 38px;
    text-align: right;
}
</style>
